// metrics
export const MARKET_CAP = 'Market Cap'
export const TRANSACTIONS = 'Transactions'
export const TVL = 'TVL'
export const DAILY_ACTIVE_USERS = 'Average DAU'
export const SMART_CONTRACTS = 'Smart Contracts'
export const FEES_PAID = 'Fees Paid'
export const TG_GROWTH_INDEX = 'TG Growth Index'
